// `code` is a Cognito error type (e.g. NotAuthorizedException) or one of the handoff codes below.
export class HandoffError extends Error {
    code: string;

    constructor(code: string, message?: string) {
        super(message || code);
        this.name = 'HandoffError';
        this.code = code;
    }
}

export const HANDOFF_ERROR_CODES = {
    unexpectedChallenge: 'UnexpectedChallenge',
    invalidRefreshResponse: 'InvalidRefreshResponse',
    unexpectedChallengeResponse: 'UnexpectedChallengeResponse',
    unsupportedChallenge: 'UnsupportedChallenge',
    clientMismatch: 'ClientMismatch',
    accountNotFound: 'AccountNotFound',
    poolNotAllowed: 'PoolNotAllowed',
    completeFailed: 'CompleteFailed',
};
